import { customInterceptor } from './Interceptor';

export const getAllMessages = async (projectId) => {
  try {
    // Check if projectId is provided and append it to the URL
    // Result: "messages?page=1&projectId=123"
    let url = 'messages?page=1';
    
    if (projectId) {
      url += `&projectId=${projectId}`;
    }

    const result = await customInterceptor(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getPatientActivity = async () => {
  try {
    const result = await customInterceptor('users/wc-activities');
    return result;
  } catch (error) {
    throw error;
  }
};

export const getCoachDetails = async () => {
  try {
    const result = await customInterceptor('users/me');
    return result;
  } catch (error) {
    throw error;
  }
};
export const getProjectForPatient = async (patientId) => {
  try {
    const result = await customInterceptor(`users/user-project-mapping/${patientId}`);
    return result; 
  } catch (error) {
    console.error("Error fetching project mapping", error);
    return null;
  }
};

export const getPatientLogs = async (Id, projectId) => {
  try {
    let url = `users/${Id}/logs`;
    if (projectId) {
      url += `?projectId=${projectId}`;
    }
    const result = await customInterceptor(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getPatientDetails = async (Id) => {
  try {
    const result = await customInterceptor(`users/${Id}`);
    return result;
  } catch (error) {
    throw error;
  }
};